import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["progress", "size", "className", "spanElProps", "detailBackground"];
import { useMemo } from 'react';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var ProgressBar = function ProgressBar(_ref) {
  var _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? 0 : _ref$progress,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    className = _ref.className,
    spanElProps = _ref.spanElProps,
    detailBackground = _ref.detailBackground,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sizeCustom = useMemo(function () {
    if (size === 'lg') return 'tw-h-2';
    if (size === 'm') return 'tw-h-0.8';
    return 'tw-h-0.4';
  }, [size]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({}, otherProps), spanElProps), {}, {
    className: clsx('tw-inline-block', 'tw-relative',
    // REMOVE TEXT-LINE LIKE BEHAVIOR OF INLINE-BLOCK ELEMENTS => https://iamvdo.me/en/blog/css-font-metrics-line-height-and-vertical-align
    'tw-text-[0]', sizeCustom, detailBackground === null || detailBackground === void 0 ? void 0 : detailBackground.background, 'tw-overflow-hidden', 'tw-w-full', className),
    role: "progressbar",
    "aria-valuenow": progress,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    children: /*#__PURE__*/_jsx("span", {
      className: clsx('tw-inline-block', 'tw-h-full', detailBackground === null || detailBackground === void 0 ? void 0 : detailBackground.progressBar),
      style: {
        width: "".concat(progress, "%")
      }
    })
  }));
};
ProgressBar.defaultProps = {
  detailBackground: {
    background: 'tw-bg-neutral-light-500 dark:tw-bg-neutral-dark-400',
    progressBar: 'tw-bg-primary-light-500 dark:tw-bg-primary-light-400'
  }
};
export default ProgressBar;